<template>
  <div id="vacationTab">
    <div>
      <a-row type="flex">
        <a-col v-if="isAdmin ||
          userAccess.indexOf('HR') != -1 ||
          userAccess.indexOf('CEO') != -1
          ">
          <h2>{{ $t("Sposob uzycia") }}</h2>
        </a-col>
        <a-col v-else>
          <h2>{{ $t("employee") }}</h2>
        </a-col>
        <a-col v-if="isAdmin ||
          userAccess.indexOf('HR') != -1 ||
          userAccess.indexOf('CEO') != -1
          " style="margin: 0 60px 0 15px">
          <a-radio-group default-value="one" button-style="solid" @change="onChangeMode">
            <a-radio-button value="one">
              <a-icon type="user-add" />
            </a-radio-button>
            <a-radio-button value="all">
              <a-icon type="usergroup-add" />
            </a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col v-else style="margin: 0 60px 0 15px">
          <h2>
            <a-avatar style="width: 25px; height: 25px; margin-right: 5px" :src="currentUserObj.PERSONAL_PHOTO" />
            {{ currentUserObj.LAST_NAME + " " + currentUserObj.NAME }}
          </h2>
        </a-col>

        <a-col v-if="currentHollMode == 'one' &&
          (isAdmin ||
            userAccess.indexOf('HR') != -1 ||
            userAccess.indexOf('CEO') != -1)
          ">
          <h2 style="padding-left: 5px">{{ $t("employee") }}</h2>
        </a-col>
        <a-col v-if="currentHollMode == 'one' &&
          (isAdmin ||
            userAccess.indexOf('HR') != -1 ||
            userAccess.indexOf('CEO') != -1)
          " style="flex: 1; margin-left: 15px">
          <a-select style="width: 100%; text-align: center" showSearch :filter-option="false" :default-value="userInfo[currentUserIdForEdit].LAST_NAME +
            ' ' +
            userInfo[currentUserIdForEdit].NAME
            " :value="userInfo[currentUserIdForEdit].LAST_NAME +
    ' ' +
    userInfo[currentUserIdForEdit].NAME
    " @search="searchUser" @change="changecurrentUserIdForEdit">
            <a-select-option v-for="employee of filterUserList" :key="employee.ID" :value="employee.ID">
              <a-avatar v-if="employee.PERSONAL_PHOTO" style="width: 24px; height: 24px; margin-bottom: 3px"
                :src="employee.PERSONAL_PHOTO" />
              <a-avatar v-else style="
                  width: 25px;
                  height: 25px;
                  color: #f56a00;
                  background-color: #fde3cf;
                  margin-bottom: 3px;
                  line-height: 24px;
                  font-weight: 500;
                ">{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar>
              {{ `${employee.LAST_NAME} ${employee.NAME}` }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col v-if="currentHollMode == 'all'">
          <h2>{{ $t("Filtr") }}</h2>
        </a-col>
        <a-col v-if="currentHollMode == 'all'" style="margin-left: 15px; flex: 1">
          <a-select style="width: 100%; text-align: center" default-value="all" @change="changeFilterMode">
            <a-select-option value="all">{{ $t("allEvents") }}</a-select-option>
            <a-select-option value="department">{{
              $t("UF_DEPARTMENT")
            }}</a-select-option>
            <a-select-option value="users">{{
              $t("Employed workers")
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col v-if="currentHollMode == 'all' && filterMode == 'department'" style="flex: 1; margin-left: 15px">
          <a-select :value="departmentFilterDefault" id="dep-sel" style="width: 100%"
            @change="handleChangeDepartmentFilter">
            <a-select-option v-for="item in departments" :key="item.ID" :value="item.ID">{{ item.NAME }}</a-select-option>
          </a-select>
        </a-col>
        <a-col v-if="currentHollMode == 'all' && filterMode == 'users'" style="flex: 1; padding: 0 15px">
          <a-select mode="multiple" style="width: 100%" :value="usersFilterDefault" @change="handleChangeUsersFilter">
            <a-select-option v-for="employee of userInfo" :key="employee.ID">
              <a-avatar v-if="employee.PERSONAL_PHOTO" style="width: 24px; height: 24px; margin-bottom: 3px"
                :src="employee.PERSONAL_PHOTO" />
              <a-avatar v-else style="
                  width: 20px;
                  height: 20px;
                  color: #f56a00;
                  background-color: #fde3cf;
                  margin-bottom: 3px;
                  line-height: 20px;
                  font-weight: 500;
                ">{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar>
              {{ `${employee.LAST_NAME} ${employee.NAME}` }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </div>
    <v-app>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">{{ $t("today") }}</v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">{{
            $refs.calendar.title
          }}</v-toolbar-title>
          <v-toolbar-title v-else>{{
            moment().locale(localeApp).format("MMMM YYYY")
          }}</v-toolbar-title>

          <v-spacer></v-spacer>
          <div style="width: 200px">
            <v-select v-model="type" :items="types" dense outlined hide-details class="ma-2"></v-select>
          </div>
          <div v-if="type == 'month'" style="width: 100px">
            <v-select v-model="currentYear" :items="arrYears" dense outlined hide-details @change="moveToYear"></v-select>
          </div>
        </v-toolbar>
      </v-sheet>
      <v-sheet>
        <v-calendar ref="calendar" v-model="focus" color="primary" :locale="localeApp" :events="holidaysAllMass"
          :event-color="getEventColor" :type="type" :event-more="false" @click:event="showEvent" @click:more="viewDay"
          @click:date="viewDay" @change="updateRange"></v-calendar>

        <div class="text-center">
          <a-drawer placement="top" :closable="true" :visible="selectedOpen" @close="closeItemCalendar"
            :title="$t('What to do')">
            <!-- <div v-if="selectedEvent.name==$t('Absence') || selectedEvent.name==$t('Vacation') "> -->
            <div>
              <h2>
                <span>{{ $t("Drzyczyna") }}: {{ $t(selectedEvent.cause) }}</span>
                <br />
                <span v-if="selectedEvent.name == $t('Absence')">{{ $t("Description") }}:
                  {{ selectedEvent.description }}</span>
              </h2>
            </div>

            <a-button v-if="isAdmin ||
              userAccess.indexOf('HR') != -1 ||
              selectedEvent.name == $t('Vacation application')
              " type="danger" @click="CancelModalSelect">{{ $t("Deny") }}</a-button>

            <a-button v-if="(userAccess.indexOf('HR') != -1 ||
              userAccess.indexOf('CEO') != -1 ||
              isAdmin) &&
              selectedEvent.name == $t('Vacation application') &&
              (userInfo[currentUserIdForEdit].ID != currentUserObj.ID ||
                userAccess.indexOf('HR') != -1 ||
                isAdmin)
              " type="primary" @click="ConfirmModalSelect">{{ $t("Confirm") }}</a-button>
          </a-drawer>
        </div>

        <div class="text-center">
          <a-drawer placement="top" :closable="true" :visible="selectedOpenDate" @close="closeDateModal"
            :title="$t('What to do')">
            <a-spin :spinning="spinningAddingPeriod">
              <div>
                <a-row v-if="isAdmin ||
                  userInfo[currentUserIdForEdit].ID == currentUserObj.ID ||
                  userAccess.indexOf('CEO') != -1
                  " :style="{ padding: '2px' }" type="flex">
                  <a-col :style="{ width: '150px' }">
                    <a-button :style="{ 'background-color': '#757575', width: '100%' }" @click="
                      currentTab = 1;
                    selectSecondDate = '';
                    ">{{ $t("Vacation application") }}</a-button>
                  </a-col>
                  <a-col :style="{ flex: 1 }" v-if="currentTab == 1">
                    {{ $t("From") }}
                    <a-date-picker @change="onChangeDayFirst" :locale="localeApp"
                      :default-value="moment(selectFirstDate, dateFormat)" :format="dateFormat" />
                    {{ $t("To") }}
                    <a-date-picker @change="onChangeDayTo" :locale="localeApp" />
                    <a-select @change="setCauseHoliday" style="width: 300px" :placeholder="$t('Drzyczyna')">
                      <a-select-option v-for="type in settingsUserData.AbsType" :key="type" :value="type">{{ type
                      }}</a-select-option>
                    </a-select>
                    <a-button @click="onChangeDH" type="primary">OK</a-button>
                  </a-col>
                </a-row>
                <a-row v-if="isAdmin || userAccess.indexOf('HR') != -1" :style="{ padding: '2px' }" type="flex">
                  <a-col :style="{ width: '150px' }">
                    <a-button :style="{ 'background-color': 'green', width: '100%' }" @click="
                      currentTab = 2;
                    selectSecondDate = '';
                    causeHoliday = '';
                    ">{{ $t("Vacation") }}</a-button>
                  </a-col>
                  <a-col :style="{ flex: 1 }" v-if="currentTab == 2">
                    {{ $t("From") }}
                    <a-date-picker @change="onChangeDayFirst" :default-value="moment(selectFirstDate, dateFormat)"
                      :format="dateFormat" />
                    {{ $t("To") }}
                    <a-date-picker @change="onChangeDayTo" />
                    <a-select @change="setCauseHoliday" style="width: 300px" :placeholder="$t('Drzyczyna')">
                      <!-- <a-select-option v-for="item in Urlops" :key="item" :value="item">{{item}}</a-select-option> -->
                      <!-- <a-select-option value="Scheduled vacation">{{
                        $t("Scheduled vacation")
                      }}</a-select-option> -->
                      <a-select-option v-for="type in settingsUserData.AbsType" :key="type" :value="type">{{ type
                      }}</a-select-option>
                    </a-select>
                    <a-button @click="onChangeH" type="primary">OK</a-button>
                  </a-col>
                </a-row>
                <a-row v-if="isAdmin || userAccess.indexOf('HR') != -1" :style="{ padding: '2px' }" type="flex">
                  <a-col :style="{ width: '150px' }">
                    <a-button :style="{ 'background-color': 'red', width: '100%' }" @click="
                      currentTab = 3;
                    selectSecondDate = '';
                    causeWalk = '';
                    ">{{ $t("Absence") }}</a-button>
                  </a-col>
                  <a-col :style="{ flex: 1 }" v-if="currentTab == 3">
                    {{ $t("From") }}
                    <a-date-picker @change="onChangeDayFirst" :locale="localeApp"
                      :default-value="moment(selectFirstDate, dateFormat)" :format="dateFormat" />
                    {{ $t("To") }}
                    <a-date-picker @change="onChangeDayTo" :locale="localeApp" />

                    <a-select @change="setCauseWalk" style="width: 300px" :placeholder="$t('Drzyczyna')">
                      <a-select-option v-for="type in settingsUserData.AbsenceType" :key="type" :value="type">{{ type
                      }}</a-select-option>
                    </a-select>

                    <a-input style="display: inline-block; width: 300px" :placeholder="$t('Description')"
                      v-model="selectItemDescription" />
                    <a-button type="primary" @click="onChangeW">OK</a-button>
                  </a-col>
                </a-row>
              </div>
            </a-spin>
          </a-drawer>
        </div>
      </v-sheet>
    </v-app>

    <div v-if="currentHollMode == 'one'">
      <a-row type="flex" style="text-align: center">
        <a-col style="flex: 1">
          <h3>{{ $t("Przelozony") }}</h3>
          <p>
            <!-- <span
              v-for="(iteration, index) in userInfo[currentUserIdForEdit]
                .UF_DEPARTMENT"
              :key="iteration"
            >
              <a-tag v-if="checkBoss(index)" color="blue">{{
                getUserInfo(index, [
                  "LAST_NAME",
                  "NAME",
                  { field: "WORK_POSITION", brackets: true },
                ])
              }}</a-tag>
            </span> -->

            <span>
              <div>
                {{
                  getUserInfo(0, [
                    "LAST_NAME",
                    "NAME",
                    { field: "WORK_POSITION", brackets: true },
                  ])
                }}
              </div>
            </span>
          </p>
        </a-col>
        <a-col style="flex: 1">
          <a-progress :width="80" type="dashboard" :percent="100" strokeColor="green" status="active"
            :format="(percent) => `${DniWRoku}`" />
          <p>{{ $t("allDays") }}</p>
        </a-col>
        <a-col style="flex: 1">
          <a-progress :width="80" type="dashboard" :percent="100" strokeColor="yellow" status="active"
            :format="(percent) => `${UzywaneDni}`" />
          <p>{{ $t("usedDays") }}</p>
        </a-col>
        <a-col style="flex: 1">
          <a-progress :width="80" type="dashboard" :percent="100" strokeColor="red" status="active"
            :format="(percent) => `${DniNieobecnosci}`" />
          <p>{{ $t("walkDays") }}</p>
        </a-col>
        <a-col style="flex: 1">
          <a-progress :width="80" type="dashboard" :percent="100" strokeColor="gray" status="active"
            :format="(percent) => `${+DniWRoku - +UzywaneDni}`" />
          <!-- <a-progress
            :width="80"
            type="dashboard"
            :percent="100"
            strokeColor="gray"
            status="active"
            :format="percent => `${EwentualniePozostalo}`"
          /> -->
          <p>{{ $t("confirmDays") }}</p>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { updateAuth, generateFormData } from "../requestFunc";

export default {
  props: [
    "userInfo",
    "departments",
    "currentUserIdForEdit",
    "holidaysAllMass",
    "eventID",
    "UzywaneDni",
    "DniWRoku",
    "DniNieobecnosci",
    "EwentualniePozostalo",
    "DataAktualizacji",
    "userAccess",
    "currentUserObj",
    "isAdmin",
    "localeApp",
    "currentBxUserDepartments",
    "infoo_currentUsersInDepartments",
    "settingsUserData",
  ],
  data() {
    return {
      type: "month",
      // types: ["month", "week", "day"],
      types: [
        { value: "month", text: this.$t("month") },
        { value: "week", text: this.$t("week") },
        { value: "day", text: this.$t("day") },
      ],
      selectFirstDate: null,
      selectSecondDate: null,
      selectItemDescription: "",
      currentYearInCalendar: "2022",
      Nieobecnoscs: [
        "Choroba",
        "Dod. u. macierzynski",
        "Dzien wolny za swieto przypadajace w sobote",
        "Opieka nad chorym czlonkiem rodziny",
        "Opieka nad chorym dzieckiem do 14 lat",
        "Opieka nad zdrowym dzieckiem do 8 lat",
        "Szkolenie",
        "U. macierzynski",
        "U. wychowawczy",
        "Wypadek przy pracy",
        "Wypadek w drodze do/z pracy",
      ],
      Urlops: ["holiday cause 1", "holiday cause 2", "holiday cause 3"],

      dateFormat: "YYYY-MM-DD",
      // visibleModalDaysSimilar: false,

      currentYear: new Date().getFullYear(),
      yearBetween: new Date().getFullYear(),
      arrYears: Array(100)
        .fill(0)
        .map((e, i) => 2009 + i + 1),

      focus: "",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      selectedOpenDate: false,
      events: [],
      colors: ["green", "red", "#757575"],
      names: ["Urlop", "Nieobecnosc", "Wniosek o urlop"],
      toggle_multiple: ["dreamHoliday", "holiday", "absenteeism"],
      causeWalk: "",
      causeHoliday: "",
      causeDreamHoliday: "",
      currentTab: 0,
      currentHollMode: "one",
      filterMode: "all",
      holidaysAllMassCopy: null,
      usersFilterDefault: [],
      departmentFilterDefault: "",
      spinningAddingPeriod: false,
      searchUserInput: "",
    };
  },
  methods: {
    moment,
    handleChangeUsersFilter(value) {
      this.usersFilterDefault = value;
      if (this.holidaysAllMassCopy === null) {
        this.holidaysAllMassCopy = this.holidaysAllMass.slice();
      }
      this.holidaysAllMass = this.holidaysAllMassCopy.filter((item) => {
        if (value.indexOf(item.userID) + 1) return item;
      });
    },
    handleChangeDepartmentFilter(value) {
      this.departmentFilterDefault = value;
      if (this.holidaysAllMassCopy === null) {
        this.holidaysAllMassCopy = this.holidaysAllMass.slice();
      }
      let massDep = this.userInfo
        .filter((el) => {
          if (el.UF_DEPARTMENT.indexOf(+value) + 1) {
            return el;
          }
        })
        .map((item) => item.ID);
      this.holidaysAllMass = this.holidaysAllMassCopy.filter((item) => {
        if (massDep.indexOf(item.userID) + 1) return item;
      });
    },
    changeFilterMode(value) {
      if (value == "all") {
        this.$emit("onChangeHolidayMode", value);
      } else if (value == "department") {
        this.usersFilterDefault = [];
      } else if (value == "users") {
        this.departmentFilterDefault = "";
      }
      this.filterMode = value;
    },
    onChangeMode(event) {
      this.currentHollMode = event.target.value;
      this.$emit("onChangeHolidayMode", event.target.value);
    },
    // getUserInfo(dep_index, keys = []) {
    //   let dep = this.getDepartmentInfo(dep_index);
    //   let user = dep
    //     ? this.userInfo.find((item) => dep.UF_HEAD == item.ID)
    //     : false;
    //   let res = "";
    //   if (user) {
    //     for (let i of keys) {
    //       if (typeof i == "object") {
    //         if (i.brackets && user[i.field]) res += ` (${user[i.field]})`;
    //       } else {
    //         res += ` ${user[i]}`;
    //       }
    //     }
    //   }
    //   return res == "" ? "-" : res;
    // },
    checkBoss(dep_index) {
      let dep = this.getDepartmentInfo(dep_index);
      if (dep.UF_HEAD == this.userInfo[this.currentUserIdForEdit].ID)
        return false;
      else return true;
    },
    // getUserInfo(dep_index, keys = []) {
    //   let dep = this.getDepartmentInfo(dep_index);
    //   if (dep.UF_HEAD == this.userInfo[this.currentUserIdForEdit].ID) return;
    //   let user = dep
    //     ? this.userInfo.find((item) => dep.UF_HEAD == item.ID)
    //     : false;
    //   let res = "";
    //   if (user) {
    //     for (let i of keys) {
    //       if (typeof i == "object") {
    //         if (i.brackets && user[i.field]) res += ` (${user[i.field]})`;
    //       } else {
    //         res += ` ${user[i]}`;
    //       }
    //     }
    //   }
    //   if (res == "") res = "-";

    //   //
    //   let dep2 = this.departments[0];

    //   if (dep.ID != dep2.ID) {
    //     let user2 = dep2
    //       ? this.userInfo.find((item) => dep2.UF_HEAD == item.ID)
    //       : false;
    //     let res2 = "";
    //     if (user2) {
    //       for (let i of keys) {
    //         if (typeof i == "object") {
    //           if (i.brackets && user2[i.field]) res2 += ` (${user2[i.field]})`;
    //         } else {
    //           res2 += ` ${user2[i]}`;
    //         }
    //       }
    //     }
    //     if (res2 == "") res2 = "-";
    //     res += ` (${res2})`;
    //   }
    //   //

    //   return res;
    // },
    getUserInfo(dep_index, keys = []) {
      if (this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT.length == 1) {
        let dep = this.getDepartmentInfo(0);
        if (dep?.UF_HEAD == this.userInfo[this.currentUserIdForEdit].ID) return;
        let user = dep
          ? this.userInfo.find((item) => dep.UF_HEAD == item.ID)
          : false;
        let res = "";
        if (user) {
          for (let i of keys) {
            if (typeof i == "object") {
              if (i.brackets && user[i.field]) res += ` (${user[i.field]})`;
            } else {
              res += ` ${user[i]}`;
            }
          }
        }
        if (res == "") res = "-";

        return res;
      } else if (
        this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT.length > 1
      ) {
        let dep2 = this.departments[0];

        let user2 = dep2
          ? this.userInfo.find((item) => dep2.UF_HEAD == item.ID)
          : false;
        let res2 = "";
        if (user2) {
          for (let i of keys) {
            if (typeof i == "object") {
              if (i.brackets && user2[i.field]) res2 += ` (${user2[i.field]})`;
            } else {
              res2 += ` ${user2[i]}`;
            }
          }
        }
        if (res2 == "") res2 = "-";

        return res2;
      }
    },
    getDepartmentInfo(dep_index, key) {
      if (this.departments) {
        let dep = this.departments.find(
          (el) =>
            el.ID ==
            this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT[dep_index]
        );
        if (dep) return key ? dep[key] : dep;
        return dep;
      }
    },
    setCauseWalk(value) {
      this.causeWalk = value;
    },
    setCauseHoliday(value) {
      this.causeHoliday = value;
    },
    setCauseDreamHoliday(value) {
      this.causeDreamHoliday = value;
    },
    async CancelModalSelect() {
      let arrEvents = this.events;

      await this.CancelPeriod(
        this.userInfo[this.currentUserIdForEdit].ID,
        this.selectedEvent
      );

      this.events = arrEvents.filter((el) => {
        if (
          el.start != this.selectedEvent.start &&
          el.end != this.selectedEvent.end &&
          el.name != this.selectedEvent.name
        ) {
          return el;
        }
      });
      this.selectedOpen = false;
    },

    findID() {
      return this.eventID[
        this.holidaysAllMass.findIndex((el) => {
          return (
            el.start == this.selectedEvent.start &&
            el.end == this.selectedEvent.end &&
            el.name == this.selectedEvent.name
          );
        })
      ];
    },
    async CancelPeriod(id, periodData) {
      const response = await fetch("/php/request.php", {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "cancelPeriod",
          user_id: id,
          periodData: JSON.stringify(periodData),
          eventID: this.findID(),
          currentYearInCalendar: this.currentYearInCalendar,
        }),
      });
      const result = await response.json();
      if (result.status == "deleted") {
        let indexEventID = this.eventID.indexOf(this.findID());
        this.$emit("deleteIndexEvent", { event: indexEventID, days: result });
      }
    },

    chechOneDep() {
      let isYourDep = false;
      if (this.departments) {
        this.departments.every((element) => {
          if (
            this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT.indexOf(
              +element.ID
            ) != -1 &&
            this.currentUserObj.ID == element.UF_HEAD
          ) {
            isYourDep = true;
            return false;
          } else {
            return true;
          }
        });
      }
      return isYourDep;
    },

    chechDepStatus() {
      let isDep = false;
      this.departments.every((element) => {
        if (this.currentUserObj.ID == element.UF_HEAD) {
          isDep = true;
          return false;
        } else {
          return true;
        }
      });
      return isDep;
    },

    async ConfirmModalSelect() {
      let isYourDep = false;
      moment(this.selectFirstDate).format(this.dateFormat)
      if (this.userAccess.indexOf("HR") == -1) {
        isYourDep = this.chechOneDep();
      }
      console.log(moment(this.selectedEvent.start).format(this.dateFormat), 'dfos')
      if (isYourDep || this.userAccess.indexOf("HR") != -1 || this.isAdmin) {
        await this.ConfirmHolidayPeriod(
          this.userInfo[this.currentUserIdForEdit].ID,
          {
            name: this.names[0],
            start: moment(this.selectedEvent.start).format(this.dateFormat),
            end: moment(this.selectedEvent.end).format(this.dateFormat),
            color: this.colors[0],
            cause: this.selectedEvent.cause,
          }
        );
        // }
      } else {
        this.$message.warning(this.$t("Confirmation access denied!!!"));
      }
      this.selectedOpen = false;
    },
    async ConfirmHolidayPeriod(id, periodData) {
      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "ConfirmHolidayPeriod",
          user_id: id,
          periodData: JSON.stringify(periodData),
          eventID: this.findID(),
        }),
      });

      const result = await response.json();

      if (result.data.status == "confirmed") {
        let obj = {};
        periodData.start = new Date(periodData.start);
        obj.id = this.findID();
        obj.useDays = result.useDays;
        obj.waitingConfirmed = result.waitingConfirmed;
        obj.timeOff = result.timeOff;

        obj.period = JSON.parse(result.data.calendarInfo);

        this.$emit("changeEventHoliday", obj);
      }
    },

    async onChangeH() {
      // Назначить каникулы
      if (this.selectFirstDate && this.selectSecondDate) {
        this.spinningAddingPeriod = true;
        this.holidaysAllMass.every((element) => {
          if (
            +moment(this.selectFirstDate).format("YYYYMMDD") <=
            +moment(element.end).format("YYYYMMDD") &&
            +moment(this.selectSecondDate).format("YYYYMMDD") >=
            +moment(element.start).format("YYYYMMDD")
          ) {
            this.selectedOpenDate = false;
            this.$message.warning(this.$t("There are invalid dates"));
            return false;
          } else {
            return true;
          }
        });

        if (this.selectedOpenDate) {
          await this.addCalendarPeriod(
            this.userInfo[this.currentUserIdForEdit].ID,
            {
              name: this.names[0],
              start: this.selectFirstDate,
              end: moment(this.selectSecondDate).format("YYYY-MM-DD"),
              color: this.colors[0],
              cause: this.causeHoliday,
            }
          );

          this.$emit("setAllHolidayDay", {
            name: this.names[0],
            start: this.selectFirstDate,
            end: this.selectSecondDate,
            color: this.colors[0],
            cause: this.causeHoliday,
          });

          this.selectedOpenDate = false;
          this.selectSecondDate = "";
          this.selectItemDescription = "";
          this.currentTab = 0;
        }
        this.spinningAddingPeriod = false;
      } else {
        this.$message.warning(this.$t("There are invalid dates"));
      }
    },
    async onChangeW() {
      // добавить прогул
      if (this.selectFirstDate && this.selectSecondDate) {
        this.spinningAddingPeriod = true;
        this.holidaysAllMass.every((element) => {
          if (
            +moment(this.selectFirstDate).format("YYYYMMDD") <=
            +moment(element.end).format("YYYYMMDD") &&
            +moment(this.selectSecondDate).format("YYYYMMDD") >=
            +moment(element.start).format("YYYYMMDD")
          ) {
            this.selectedOpenDate = false;
            this.$message.warning(this.$t("There are invalid dates"));
            return false;
          } else {
            return true;
          }
        });

        if (this.selectedOpenDate) {
          await this.addCalendarPeriod(
            this.userInfo[this.currentUserIdForEdit].ID,
            {
              name: this.names[1],
              start: this.selectFirstDate,
              end: moment(this.selectSecondDate).format("YYYY-MM-DD"),
              color: this.colors[1],
              description: this.selectItemDescription,
              cause: this.causeWalk,
            }
          );

          this.$emit("setAllHolidayDay", {
            name: this.names[1],
            start: this.selectFirstDate,
            end: this.selectSecondDate,
            color: this.colors[1],
            description: this.selectItemDescription,
            cause: this.causeWalk,
          });
          this.selectedOpenDate = false;
          this.selectSecondDate = "";
          this.selectItemDescription = "";
          this.currentTab = 0;
        }
        this.spinningAddingPeriod = false;
      } else {
        this.$message.warning(this.$t("There are invalid dates"));
      }
    },
    async onChangeDH() {
      if (this.selectFirstDate && this.selectSecondDate) {
        this.spinningAddingPeriod = true;
        this.holidaysAllMass.every((element) => {
          if (
            +moment(this.selectFirstDate).format("YYYYMMDD") <=
            +moment(element.end).format("YYYYMMDD") &&
            +moment(this.selectSecondDate).format("YYYYMMDD") >=
            +moment(element.start).format("YYYYMMDD")
          ) {
            this.selectedOpenDate = false;
            this.$message.warning(this.$t("There are invalid dates"));
            return false;
          } else {
            return true;
          }
        });

        if (this.selectedOpenDate) {
          await this.addCalendarPeriod(
            this.userInfo[this.currentUserIdForEdit].ID,
            {
              name: this.names[2],
              start: this.selectFirstDate,
              end: moment(this.selectSecondDate).format("YYYY-MM-DD"),
              color: this.colors[2],
              cause: this.causeHoliday,
            }
          );

          this.$emit("setAllHolidayDay", {
            name: this.names[2],
            start: this.selectFirstDate,
            end: this.selectSecondDate,
            color: this.colors[2],
            cause: this.causeHoliday,
          });

          this.selectedOpenDate = false;
          this.selectSecondDate = "";
          this.selectItemDescription = "";
          this.currentTab = 0;
        }
        this.spinningAddingPeriod = false;
      } else {
        this.$message.warning(this.$t("There are invalid dates"));
      }
    },

    async addCalendarPeriod(id, periodData) {
      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "addCalendarPeriod",
          user_id: id,
          periodData: JSON.stringify(periodData),
        }),
      });
      const result = await response.json();
      if (result.status == "success") {
        this.$emit("setEventID", result.data.eventID);
        this.$emit("loadSelectedHolideyData", 3);
      }
    },
    searchUser(value) {
      this.searchUserInput = value;
    },
    changecurrentUserIdForEdit(index) {
      let key = this.userInfo.findIndex((el) => el.ID == index);
      this.$emit("changecurrentUserIdForEdit", key);
      this.$emit("loadSelectedHolideyData", 3);
    },
    handleOkModalDaysSimilar() {
      this.visibleModalDaysSimilar = false;
    },
    viewDay({ date }) {
      // this.focus = date;
      // this.type = "day";
      if (this.currentHollMode == "one") {
        this.currentTab = 0;
        this.selectSecondDate = "";
        this.selectFirstDate = date;
        if (this.holidaysAllMass.length > 0) {
          this.holidaysAllMass.every((element) => {
            if (
              +moment(this.selectFirstDate).format("YYYYMMDD") >=
              +moment(element.start).format("YYYYMMDD") &&
              +moment(this.selectFirstDate).format("YYYYMMDD") <=
              +moment(element.end).format("YYYYMMDD")
            ) {
              this.selectedOpenDate = false;
              this.$message.warning(this.$t("There are invalid dates"));
              return false;
            } else {
              this.selectedOpenDate = true;
              return true;
            }
          });
        } else {
          this.selectedOpenDate = true;
        }
      }
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
      this.currentYear = new Date().getFullYear();
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    moveToYear(value) {
      let number_move = (this.currentYear - this.yearBetween) * 12;
      this.$refs.calendar.move(number_move);
      this.yearBetween = value;
    },
    showEvent({ nativeEvent, event }) {
      if (this.currentHollMode == "one") {
        const open = () => {
          this.selectedEvent = event;
          this.selectedElement = nativeEvent.target;
          setTimeout(() => (this.selectedOpen = true), 10);
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          setTimeout(open, 10);
        } else {
          open();
        }
        nativeEvent.stopPropagation();
      }
    },
    onChangeDayTo(date) {
      this.selectSecondDate = date === null ? null : date._d;
      if (this.selectFirstDate !== null && this.selectSecondDate !== null) {
        if (
          +moment(this.selectSecondDate).format("YYYYMMDD") <
          +moment(this.selectFirstDate).format("YYYYMMDD")
        ) {
          this.$message.warning(this.$t("warning message date"));
          this.selectSecondDate = null;
        }
      }
    },
    onChangeDayFirst(date) {
      this.selectFirstDate = date === null ? null : date._d;
      if (this.selectFirstDate !== null && this.selectSecondDate !== null) {
        if (
          +moment(this.selectSecondDate).format("YYYYMMDD") <
          +moment(this.selectFirstDate).format("YYYYMMDD")
        ) {
          this.$message.warning(this.$t("warning message date"));
          this.selectFirstDate = null;
          this.selectSecondDate = null;
        }
      }
    },
    closeDateModal() {
      this.selectedOpenDate = false;
      this.selectSecondDate = "";
      this.selectItemDescription = "";
    },
    closeItemCalendar() {
      this.selectedOpen = false;
      this.selectSecondDate = "";
      this.selectItemDescription = "";
      this.currentTab = 0;
    },
    updateRange(year) {
      if (year.start.year != this.currentYearInCalendar) {
        this.currentYearInCalendar = year.start.year;
        this.$emit("loadHolidaysData", {
          id: this.currentUserObj.ID,
          currentYearInCalendar: this.currentYearInCalendar,
        });
        // console.log(this.currentUserObj, 'currentUserObj');
      }

      const events = [];

      for (let i = 0; i < this.holidaysAllMass.length; i++) {
        events.push(this.holidaysAllMass[i]);
      }

      this.events = events;
    },
  },
  computed: {
    filterUserList() {
      return this.userInfo
        .map((el, index) => ({ ...el, index }))
        .filter((el) => {
          return (
            (el.LAST_NAME + " " + el.NAME)
              .toLowerCase()
              .indexOf(this.searchUserInput.toLowerCase()) > -1
          );
        });
    },
  },

  mounted() {
    console.log("df1");
    this.$refs.calendar.checkChange();
    BX24.fitWindow();
  },
  updated() {
    this.$refs.calendar.checkChange();
  },
};
</script>

<style>
.headerListData .ant-list-item-meta {
  padding: 5px;
}

.headerListData .ant-list-item-meta-content {
  text-align: left;
  margin: auto;
}

.headerListData .ant-list-item-meta-description {
  color: white;
}

.itemsInfo,
.itemsInfoTitle {
  display: block;
  width: 50%;
  color: black;
  text-align: left;
  padding-left: 5px;
  margin: 0;
}

.itemsInfo {
  border-left: 1px solid lightgray;
}

.headerListData .ant-list-item {
  border-radius: 4px 4px 0 0;
  background-color: #0083dc;
  padding-left: 5px;
}

#vacationData .ant-list-item {
  padding: 0;
}

#vacationData {
  margin-bottom: 10px;
}

.ant-fullcalendar-date {
  background-color: brown;
}

.events {
  background-color: brown;
  margin: 0;
  padding: 0;
}

.v-application {
  padding: 5px;
  margin-bottom: 15px;
}

.v-application>.v-application--wrap {
  min-height: 0vh;
}

.v-calendar-weekly {
  height: auto !important;
}

div>pl-1 {
  margin: 1px;
}

#vacationTab {
  font-weight: 400;
  color: #000;
}

#vacationTab h2,
#vacationTab h3 {
  font-weight: 500;
}

#vacationTab .toolbar__title {
  font-size: 1rem;
}
</style>
